export default {
  export: {
    excel: "Export Excel",
    csv: "CSV",
    busy: "Exporting…",
    error: "Could not export",
    orgTitle: "Export all of the organisation's data",
    orgIntro: "A ZIP with one CSV and one JSON per entity: products and competitors (with rules and parallel imports), accounts and their alerts, the severities, critical alerts and texts you have changed, the events with their marks, the candidates with their resolution, the report templates and the alerts sent.",
    orgButton: "Download ZIP",
  },
};
